import React from 'react';
import { Box, Heading, Text, Button, VStack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();

  return (
    <Box textAlign="center" py={10}>
      <VStack spacing={6}>
        <Heading as="h1" size="4xl">404</Heading>
        <Heading as="h2" size="xl">Page Not Found</Heading>
        <Text>The page you're looking for doesn't exist or has been moved.</Text>
        <Button colorScheme="teal" onClick={() => navigate('/')}>
          Return to Dashboard
        </Button>
      </VStack>
    </Box>
  );
}

export default NotFound;
